export const loadAndInjectFonts = async (langKey) => {
    const response = await fetch(`https://www.ikea.com/global/assets/fonts/${langKey}/font-fragment.html`, { mode: "cors" });
    const xmlString = await response.text();
    const doc = new DOMParser().parseFromString(xmlString, "text/html");
    const fontsLink = doc.head.firstChild;
    if (fontsLink !== null) {
        document.head.appendChild(fontsLink);
        const style = document.createElement("style");
        style.textContent = `
      :root {
        --ikea-font: "Noto IKEA", sans-serif !important;
      }
      html {
        --font-fallback: "Noto IKEA", sans-serif !important;
        --global-font-body: "Noto IKEA", sans-serif !important;
      }
    `;
        document.head.appendChild(style);
    }
};
//# sourceMappingURL=loadAndInjectFonts.js.map